import PropTypes from "prop-types";
import { useState } from "react";

import styled from "styled-components/macro";

import FnrTypography from "FnrTypography/FnrTypography";

import FnrIcon from "UI/FnrIcon/FnrIcon";
import FnrHorizontalGap from "UI/commonContainers/FnrHorizontalGap/FnrHorizontalGap";
import FnrVerticalGap from "UI/commonContainers/FnrVerticalGap/FnrVerticalGap";

import FlocknotePeopleTrialButtons from "splashes/FlocknotePeopleButtons/FlocknotePeopleButtons";

const FPSplashContainer = styled("div")`
  background-image: linear-gradient(
    to right top,
    #051937,
    #004d7a,
    #008793,
    #00bf72,
    #a8eb12
  );
  padding: 20px;
  border-radius: 8px;
`;

const GifContainer = styled("img")`
  max-height: 160px;
  margin: 0 auto;
  border-radius: 8px;
`;

const IconContainer = styled("span")`
  ${({
    theme: {
      colors: { textLight },
    },
  }) => `
    color: ${textLight};
    font-size: 80px;
    transform: rotate(6deg);
  `}
`;

const gifs = [
  "https://media.giphy.com/media/3oEhmDF8PZDtSNjFAI/giphy.gif",
  "https://media.giphy.com/media/4UMgC1X6SX7AA/giphy.gif",
  "https://media.giphy.com/media/3oKIPnbKgN3bXeVpvy/giphy.gif",
  "https://media.giphy.com/media/7hCv6pimfBHq/giphy.gif",
  "https://media.giphy.com/media/R1hGuGznLMDp6/source.gif",
];

const defaultTitle = "Bada bing!";

const defaultBody = () => {
  return (
    <>
      This is a premium feature included with our <em>Flocknote Complete</em>{" "}
      plan! Ask your members for any information you want, like their mailing
      address, birthday, shirt size, sacramental records, (and much more!) and
      easily keep it tracked in their profiles.
    </>
  );
};

const FlocknotePeopleSplash = ({
  title = defaultTitle,
  body,
  successCallback,
}) => {
  const [gifUrl] = useState(gifs[Math.floor(Math.random() * gifs.length)]);

  return (
    <FPSplashContainer>
      <FnrVerticalGap $gap="18px" data-cy="FlocknotePeopleSplash">
        <FnrHorizontalGap>
          <FnrVerticalGap>
            <FnrTypography color="textLight" fontSize="xl" fontWeight={400}>
              {title}
            </FnrTypography>
            <FnrTypography color="textLight">
              {body || defaultBody()}
            </FnrTypography>
          </FnrVerticalGap>
          <IconContainer>
            <FnrIcon icon="fa-info-circle fa" />
          </IconContainer>
        </FnrHorizontalGap>
        <GifContainer src={gifUrl} alt="goofy-gif" />
        <FnrTypography color="textLight" fontSize="sm">
          Upgrade to Flocknote Complete to unlock a robust, integrated database
          that supercharges your member management and engagement. Add{" "}
          <strong>$75 / month. No contracts. Cancel anytime.</strong>
        </FnrTypography>
        <FlocknotePeopleTrialButtons successCallback={successCallback} />
      </FnrVerticalGap>
    </FPSplashContainer>
  );
};

FlocknotePeopleSplash.propTypes = {
  successCallback: PropTypes.func,
};

export default FlocknotePeopleSplash;
